export enum MenuType {
  GLOVO = "Glovo",
  WOLT = "Wolt",
  YANDEX = "Yandex",
  EXPRESS24 = "Express24"
}